import { render } from "./SpacesPage.vue?vue&type=template&id=1e9c8eb3&scoped=true"
import script from "./SpacesPage.vue?vue&type=script&lang=js"
export * from "./SpacesPage.vue?vue&type=script&lang=js"

import "./SpacesPage.vue?vue&type=style&index=0&id=1e9c8eb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9c8eb3"]])

export default __exports__